import { render, staticRenderFns } from "./TableContentsAgent.vue?vue&type=template&id=1dad5399&"
import script from "./TableContentsAgent.vue?vue&type=script&lang=js&"
export * from "./TableContentsAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports